<template>
  <v-container>
    <v-row wrap>
      <v-flex xs2>
        <v-btn
          color="orange"
          text
          large
          @click="$router.push({'name': 'Admin'})"
        >
          < Admin Home
        </v-btn>
      </v-flex>
      <v-flex xs8 class="text-center">
        <span class="mr-5 headline pa-2">Manage User Accounts</span>


      </v-flex>
      <v-flex xs2>

      </v-flex>
    </v-row>

    <v-card class="pa-5" outlined flat>
      <div class="title">Migrate Cards</div>
      <v-text-field label="Cards" v-model="cardsToMigrate"></v-text-field>
      <v-text-field label="Target Deck" v-model="targetDeck"></v-text-field>
      <v-btn @click="migrateCards()">Migrate Cards</v-btn>
    </v-card>




    </v-card>

    <v-card>
      <span class="mr-5 headline pa-2">Find Legacy Cards</span>
      <v-btn :loading="query" @click="findLegacyCards">Find Cards</v-btn>




    </v-card>


  </v-container>


</template>
<script>
import firebase from 'firebase'
export default {
  name: 'ManageUsers',
  data() {
    return {
      cardsToMigrate: null,
      targetDeck: null,
      cards: [],
      query: false

    }
  },
  mounted() {

  },
  methods: {
    findLegacyCards(){
      this.query = true
      firebase.firestore().collection('decks').get().then(snapshot => {
        snapshot.forEach(card => {
          let data = card.data()
          data.id = card.id
          this.cards.push(data)

        })
        console.log(JSON.stringify(this.cards))
        this.query = false
      })
    },
    error(url) {
      if (url.length > 0) {
        let first = url.includes('https://firebasestorage.googleapis.com/v0/b/learn-med.appspot.com')
        return first
      }
      return false
    },


    migrateCards() {
      firebase.firestore().collection('decks').doc(this.targetDeck).get().then(doc => {
        if (doc.exists) {
          return true
        }
        else {
          throw new Error('Valid deckId not found')
        }
      }).then(() => {
        if (this.cardsToMigrate != null) {
          let cardsArray = this.cardsToMigrate.replace(" ", "").split(',')
          console.log("Card Array:", cardsArray)

          let batch = firebase.firestore().batch()
          let ref = firebase.firestore().collection('cards')

          cardsArray.forEach(id => {
            batch.update(ref.doc(id), {'deck': this.targetDeck})
          })
          return batch.commit()

        }
      }).then(result => {
        console.log("done")
      })

//EDb8cykCQaT5fhMxvg0g,eiaoDxylBkABmL5DlSA0

    }

  }
}
</script>
